/* Utilities */

import { createSelector } from 'reselect'

const asset = (state) => state.asset
const uploadAssetTid = (state, props) => props.tid

export const getList = createSelector(
  [ asset ],
  (asset) => {
    return Object.assign(
      {},
      { list: asset.list.list }
    )
  }
)

export const getUploadList = createSelector(
  [ asset ],
  (asset) => {
    return Object.assign(
      {},
      { uploadList: asset.list.uploadList }
    )
  }
)


export const getFilter = createSelector(
  [ asset ],
  (asset) => {
    return Object.assign(
      {},
      { filter: asset.list.filter }
    )
  }
)

export const getSort = createSelector(
  [ asset ],
  (asset) => {
    return Object.assign(
      {},
      { sort: asset.list.sort }
    )
  }
)

export const getPagination = createSelector(
  [ asset ],
  (asset) => {
    return Object.assign(
      {},
      {
        pagination: asset.list.pagination
      }
    )
  }
)

export const getQuery = createSelector(
  [ asset ],
  (asset) => {
    return Object.assign(
      {},
      {
        query: asset.list.query
      }
    )
  }
)

export const getUploadItem = createSelector(
  [ asset, uploadAssetTid ],
  (asset, uploadAssetTid) => {
    return Object.assign(
      {},
      asset.list.uploads[uploadAssetTid]
    )
  }
)

export const getItem = (state, uid) => {
  const {
    items,
    metaData,
  } = state.asset.list

  return Object.assign(
    {},
    (items[uid])?items[uid]:{pending:true},
    { uid }
  )
}


export const getAssetFilter = (state) => {
  return state.asset.list.filter
}



// WEBPACK FOOTER //
// ./src/app/react-redux/selectors/asset.js